/**
 * @generated SignedSource<<ac0f5ad84bb663eabe11e682a91ebacc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type cursosLoaderQuery$variables = {
  club: string;
};
export type cursosLoaderQuery$data = {
  readonly club: {
    readonly batchJobs: ReadonlyArray<{
      readonly __typename: string;
      readonly id: string;
    }>;
    readonly communityEnabled: string | null | undefined;
    readonly coursePage: {
      readonly categories: ReadonlyArray<{
        readonly id: string;
      }>;
    };
    readonly coursesEnabled: string | null | undefined;
    readonly leaderboardEnabled: string | null | undefined;
  };
};
export type cursosLoaderQuery = {
  response: cursosLoaderQuery$data;
  variables: cursosLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "club"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "club"
  }
],
v2 = {
  "alias": "leaderboardEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "LEADERBOARD"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"LEADERBOARD\")"
},
v3 = {
  "alias": "communityEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "COMMUNITY_ENABLED"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"COMMUNITY_ENABLED\")"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "status",
      "value": "ALL"
    }
  ],
  "concreteType": "CourseCategory",
  "kind": "LinkedField",
  "name": "categories",
  "plural": true,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": "categories(status:\"ALL\")"
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "status",
      "value": "PENDING"
    }
  ],
  "concreteType": null,
  "kind": "LinkedField",
  "name": "batchJobs",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "storageKey": "batchJobs(status:\"PENDING\")"
},
v7 = {
  "alias": "coursesEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "COURSES_ENABLED"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"COURSES_ENABLED\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cursosLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CoursePage",
            "kind": "LinkedField",
            "name": "coursePage",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cursosLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CoursePage",
            "kind": "LinkedField",
            "name": "coursePage",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "48eb1905ff9ab3f6de5586572da538b8",
    "id": null,
    "metadata": {},
    "name": "cursosLoaderQuery",
    "operationKind": "query",
    "text": "query cursosLoaderQuery(\n  $club: String!\n) {\n  club(slug: $club) {\n    leaderboardEnabled: configuration(key: \"LEADERBOARD\")\n    communityEnabled: configuration(key: \"COMMUNITY_ENABLED\")\n    coursePage {\n      categories(status: ALL) {\n        id\n      }\n      id\n    }\n    batchJobs(status: PENDING) {\n      id\n      __typename\n    }\n    coursesEnabled: configuration(key: \"COURSES_ENABLED\")\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6e591f4509cd18a86cd4e12c35b8d91c";

export default node;
